import React, { useContext } from 'react';
import Chart from 'react-google-charts';

import { Card, CardHeader } from '@material-ui/core';
import DashboardContext from 'src/pages/Private/Dashboard/context';
import { defaultChartOptions } from 'src/utils/charts';

const BeneficiariesSolicitationsChart: React.FC = () => {
  const {
    chartsInfo: { beneficiariesSolicitations },
  } = useContext(DashboardContext);

  return (
    <Card style={{ height: '100%' }}>
      <CardHeader
        style={{ color: '#01CB98' }}
        title="IFEPAF"
        subheader="4 BENEFICIÁRIAS QUE MAIS UTILIZAM"
      />

      <Chart
        chartType="ColumnChart"
        data={beneficiariesSolicitations}
        options={defaultChartOptions}
      />
    </Card>
  );
};

export default BeneficiariesSolicitationsChart;
